<div class="dashboard-title-block">
		<div class="dashboard-title-label" translate>news.last-news</div>
		<div class="dashboard-element-align-right">
			<button type="button" mat-button class="dashboard-customize-button" [routerLink]="['/home/news-list']">
				<span translate>news.view-all</span>
			</button>
		</div>
</div>
<div class="news-list-widgets" *ngIf="newsList">
	<div class="news-widget" *ngFor="let news of newsList">
		<div class="news-title-widget">{{news.title}}</div>
		<div class="news-content-widget" [innerHTML]="news.content"></div> 
		<div class="card-container-column news-from-to-date" translate>
			filter.number.from&nbsp;
				<span> {{news.from | date: 'YYYY-MM-dd HH:mm'}}</span>
			<span translate>&nbsp;filter.date.to&nbsp;
				<span >{{news.to | date: 'YYYY-MM-dd HH:mm'}} </span>
			</span>
		</div>
		<div class="news-footer-widget">
			<button type="button" mat-button color="primary" (click)="viewDetails(news.id!)">
				<span translate>order-tracking.card.delivery-date.view-details</span>
				<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
			</button>
		</div>
	</div>
</div>